import React from 'react'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { View } from 'react-native'
import { useResponsive } from '../../utils/hooks'

export const HEADER_HEIGHT = 58

export const CustomHeader = ({ containerStyle, scene }) => {
  const options = scene.descriptor
  const { mobileWidth } = useResponsive()

  if (!options.options.children) {
    return null
  }

  return (
    <View
      style={composeStyle(
        {
          height: HEADER_HEIGHT,
          width: mobileWidth,
          alignSelf: 'center',
        },
        containerStyle,
      )}
    >
      {options.options.children}
    </View>
  )
}
